export default __webpack_public_path__ + "static/media/img_2.41155855.JPG";